export const repair = {
  page_title: "Use Credits",
  page_subtitle:
    "Redeem repair credits from sold parts to fund inspections, refurbishment, and repairs at qualified shops.",
  balance_label: "Account balance",
  view_print_statement: "View / print statement",
  tab_active: "Active Requests",
  tab_completed: "Completed",
  active_empty:
    "You have no active repair credit requests. Submit a request below when you are ready.",
  completed_empty:
    "Completed repair credit uses will appear here once they are processed.",
  col_part: "Part",
  col_work_order: "Work Order",
  col_shop: "Repair Shop",
  col_opened: "Opened",
  col_cost: "Approx. Cost",
  col_status: "Status",
  col_notes: "Notes",
  col_closed: "Closed",
  col_updated: "Updated",
  col_org: "Organization",
  col_submitted_by: "Submitted By",
  col_id: "ID",
  status_open: "Open",
  status_closed: "Closed",
  empty_cell: "—",
  use_credits_cta: "Use Credits",
  submit_success:
    "Thanks — we received your request and will reach out within 24 hours.",
  submit_error: "We couldn't send that request. Please try again later.",
} as const;
